export function notify({ title, body, icon }: { title: string, body?: string, icon?: string }) {
    if (typeof Notification !== 'undefined') {
        Notification.requestPermission().then(permission => {
            if (permission === 'granted') {
                new Notification(title, { body, icon })
            }
        })
    }
}